function StartIcon({ width = 15, height = 15 }) {
  return (
    <svg width={width} height={height} viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.42438 2.95475V5.8508C3.42438 6.05627 3.6592 6.16878 3.82063 6.04159L5.63066 4.59356C5.75296 4.49573 5.75296 4.30983 5.63066 4.21199L3.82063 2.76397C3.6592 2.63677 3.42438 2.74929 3.42438 2.95475ZM7.82716 0H0.978395C0.440278 0 0 0.440278 0 0.978395V7.82716C0 8.36528 0.440278 8.80556 0.978395 8.80556H7.82716C8.36528 8.80556 8.80556 8.36528 8.80556 7.82716V0.978395C8.80556 0.440278 8.36528 0 7.82716 0ZM7.33796 7.82716H1.46759C1.19853 7.82716 0.978395 7.60702 0.978395 7.33796V1.46759C0.978395 1.19853 1.19853 0.978395 1.46759 0.978395H7.33796C7.60702 0.978395 7.82716 1.19853 7.82716 1.46759V7.33796C7.82716 7.60702 7.60702 7.82716 7.33796 7.82716Z" fill="#4C4C4C" />
    </svg>

  )
}

export default StartIcon;
